export default "/images/vendor/@coreui/icons/svg/flag/cif-ar.svg?66c3164c91eeaef2298ce259e99da036";